"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_location(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "location-hi"), /*#__PURE__*/React.createElement("g", {
    id: "d9846e58-237e-42aa-bb2e-0a528fae6a09",
    "data-name": "location-hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fe5797ff-b54e-4bac-987b-ce622eddf88a",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e53d1aa6-f874-4efe-97ae-1319334831d2",
    "data-name": "Bill_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ad6fcfe0-fd69-40dc-847b-9ad733978ab1",
    "data-name": "Report_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "732b8f4e-8745-4ecd-9839-5ca3a52d396d",
    "data-name": "vodafone_store_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "44fabf6f-a13d-4461-981c-aae715258069",
    "data-name": "Broadband_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "79b22fd2-c6d1-4ea1-b8b9-85423152c054",
    "data-name": "Business_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "16b6f169-a2bb-4c04-a02c-1611a9fb1522",
    "data-name": "Calendar_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "73dfc489-c2dd-447c-8389-ee3fe23f7444",
    "data-name": "Camera_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "42b3f446-7a68-4829-8524-e9156aaa0fa7",
    "data-name": "Data_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fb7f0902-2650-4140-ad56-6d0e3acb904c",
    "data-name": "Desktop_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7c142eb2-459a-4d39-8d8c-d017dd805e48",
    "data-name": "Document_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "305a30a6-f887-46fc-b71b-8dc73f0c52fb",
    "data-name": "Edit_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "45a8c0bf-0a54-4f95-b7e9-58bee71fa272",
    "data-name": "Enterprise_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "aece6d86-71d1-4ee5-aec6-0a79f2143bc4",
    "data-name": "Call_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3c02202c-68ab-4b7e-b7a4-bae05303fc38",
    "data-name": "Location_ic_hi"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 24,
    width: 144,
    height: 144,
    rx: 16,
    ry: 16,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,166H40a16,16,0,0,1-16-16v2a16,16,0,0,0,16,16H152a16,16,0,0,0,16-16v-2A16,16,0,0,1,152,166Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,44.32V39.79L140.34,25.13,141,24H127.5L111,54.85,79,38.21,87.06,23l-2.56.71L77.43,37,53,24H41.5L26.59,51.81,24,50.43v14.8l.5-1,30,15.93L39,109.49l-15-8v4.53l13.14,7L24,137.82v11.25L52.92,164.4,51,168H68l-2.61-1.51,15.93-30,30,15.93L103,168H112l6.4-11.85L140.53,168h8.54L120.3,152.59l15.53-29.28,30,15.93L150.77,168H152a15.86,15.86,0,0,0,3.51-.4L168,143.75v-17l-28.32-15,15.39-29L168,89.59V85.07l-11.05-5.86L168,58.36V49.82L153.41,77.33,121.61,60.47l16.86-31.81ZM109.13,58.38l-15.39,29-30-15.93,15.39-29Zm-79-4.7,15.39-29,30,15.93-15.39,29Zm28,28.4L88.12,98,72.59,127.29l-30-15.93Zm-3.29,78.78-30-15.93,15.93-30,30,15.93Zm58.44-12-30-15.93,15.53-29.28,30,15.93Zm38.31-68-15.39,29L104.34,93l15.39-29Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.86,
    cy: 95.71,
    r: 10,
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,12.32c-16.83,0-29.08,13.49-29.08,30.13C66.92,65.66,96,97.32,96,97.32s6.46-7.47,8.54-10c8.64-10.64,20.53-28.82,20.54-44.35C125.09,26.31,112.82,12.32,96,12.32Zm0,44.74A15.66,15.66,0,1,1,111.66,41.4,15.66,15.66,0,0,1,96,57.05Z",
    transform: "translate(0 0)",
    fill: "#e60100"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96,25.74A15.64,15.64,0,0,1,111.61,40.4c0-.33.05-.66.05-1a15.66,15.66,0,0,0-31.32,0c0,.34,0,.67.05,1A15.65,15.65,0,0,1,96,25.74Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.54,85.3c-2.07,2.56-8.54,10-8.54,10s-28.44-31-29.05-54.12c0,.41,0,.83,0,1.25C66.92,65.66,96,97.32,96,97.32s6.46-7.47,8.54-10c8.64-10.64,20.53-28.82,20.54-44.35,0-.35,0-.7,0-1C124.57,57.21,113,74.87,104.54,85.3Z",
    transform: "translate(0 0)"
  })))))))))))))))))));
}

var _default = ic_location;
exports.default = _default;